import * as React from 'react';
import { FieldHookConfig } from 'formik';
import { useDropzone } from 'react-dropzone';
import { styled } from '@material-ui/core';
import { TextFieldProps } from 'app/components/TextField';
import { FileCard } from './FileCard';
import { Box } from 'app/components/basic/Wrappers/Box';
import { DetectIsMobile } from 'utils/mobileDetect';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectExpandedSidePanel,
  selectSidePanelOpen,
} from 'app/Layout/FrontendLayout/slice/selectors';
import { useLargeFilesUploadSlice } from '../slice';

export interface SelectFileProps {
  accept: any;
  downloadFileName?: string;
  filesPlaceholder: React.ReactNode;
  height?: number;
  maxFilesCount?: number;
  maxSize: number;
}

export const SelectFile = ({
  label,
  onBlur,
  value,
  name,
  error,
  helperText,
  accept,
  downloadFileName,
  filesPlaceholder,
  maxFilesCount,
  maxSize,
  ...props
}: FieldHookConfig<string> & TextFieldProps & SelectFileProps) => {
  const dispatch = useDispatch();
  const { actions: largeFileActions } = useLargeFilesUploadSlice();
  const isMobile = DetectIsMobile();
  const sidePanelOpen = useSelector(selectSidePanelOpen);
  const sidePanelExpanded = useSelector(selectExpandedSidePanel);
  const showShortView = isMobile || (sidePanelOpen && !sidePanelExpanded);
  const maxFiles =
    maxFilesCount === undefined ? 1 : maxFilesCount > 20 ? 20 : maxFilesCount;
  const onDrop = React.useCallback(
    (acceptedFiles: File[]) => {
      dispatch(largeFileActions.setSeletedFiles(acceptedFiles.length));
    },
    [dispatch, largeFileActions],
  );

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: maxFiles,
    //minSize: minChunkSize,
    maxSize: maxSize,
    accept: accept,
  });
  const remorFile = React.useCallback(
    (filename: string) => {
      const index = acceptedFiles.findIndex(item => item.name === filename);
      acceptedFiles.splice(index, 1);
      dispatch(largeFileActions.setSeletedFiles(acceptedFiles.length));
    },
    [acceptedFiles, dispatch, largeFileActions],
  );
  return (
    <>
      <Box style={{ width: showShortView ? '100%' : '400px' }}>
        <StyledDropboxContainer {...getRootProps({ className: 'dropzone' })}>
          <input {...getInputProps()} />
          <p>{filesPlaceholder}</p>
        </StyledDropboxContainer>
        {acceptedFiles.length > 0 && (
          <div style={{ overflowY: 'auto', height: props.height }}>
            {acceptedFiles.map(file => (
              <FileCard file={file} remorFile={remorFile} />
            ))}
          </div>
        )}
      </Box>
    </>
  );
};
const StyledDropboxContainer = styled('div')(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: '2px',
  borderRadius: '2px',
  borderColor: theme.palette.common.grayBorders,
  borderStyle: 'dashed',
  backgroundColor: theme.palette.background.paper,
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
}));
